import { render, staticRenderFns } from "./SmsTemplateForm.vue?vue&type=template&id=3ebe7d98&"
import script from "./SmsTemplateForm.vue?vue&type=script&lang=js&"
export * from "./SmsTemplateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports